<template>
  <div>
    <v-container>
      <!-- <div class="text-xs-center titlecentralhr">Target</div> -->
      <v-layout row justify-center class="mt-5">
        <v-flex xs12 sm5>
          <div class="text-xs-center titlecentralhr">Target</div>
          <v-card style="min-height: 380px; position: relative">
            <div v-if="!loading">
              <div v-if="series.length" id="chart">
                <apexchart
                  :key="keydata"
                  type="pie"
                  width="100%"
                  :options="chartOptions"
                  :series="series"
                ></apexchart>
              </div>
              <div
                v-else
                style="
                  position: absolute;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  top: 50%;
                  font-size: 25px;
                  color: grey;
                "
              >
                ไม่พบข้อมูล
              </div>
            </div>
            <div v-else>
              <div class="text-xs-center pt-5">
                <v-progress-circular size="95" indeterminate color="primary"></v-progress-circular>
              </div>
            </div> </v-card
        ></v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {
      loading: false,
      data: '',
      series: [],
      chartOptions: {
        legend: {
          position: 'right',
          horizontalAlign: 'right',
          width: 100,
          offsetY: -20,
          offsetX: 0,
          floating: true
        },
        plotOptions: {
          pie: {
            offsetX: -50,
            size: 80
          }
        },
        chart: {
          type: 'pie'
        },
        labels: []
      }
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  async mounted() {
    this.loading = true
    await this.getData()
    this.loading = false
  },
  methods: {
    getData() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid
        }
        api.getCountActiveUser(data, (err, response) => {
          if (response.responsecode == 200) {
            let res = response.data[0]
            console.log('res : ', res)
            this.data = [
              {
                title: 'Active User',
                total: res.active
              },
              {
                title: 'Not Active User',
                total: res.total - res.active
              }
            ]
            this.series = [parseInt(res.active), parseInt(res.total - res.active)]
            this.chartOptions.labels = ['Active User', 'Not Active User']

            this.keydata++
          }
          resolve()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.titlecentralhr {
  font-weight: 600;
  margin-bottom: 10px;
  font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/centralhr/target.vue